module.exports = __webpack_public_path__ + "static/media/google.91928b2a.png";